import { listKeycards } from './index';

import { keycardsRouteStore } from '../domain/store';

export default (e) => {
  keycardsRouteStore.setValue('filterValue', e.target.value);
  keycardsRouteStore.setValue('currentPage', 1);
  return listKeycards();
};
